export class InstantiationHook {
    constructor() {
        this.hookRegistry = new Set(); // 用于注册对应ID的hook函数
    }
    addHook(hookPoint, callback) {
        this.hookRegistry.add({ hookPoint, callback });
    }
    executeHooks(instance, point) {
        this.hookRegistry.forEach((hook) => {
            const { hookPoint, callback } = hook;
            if (hookPoint === point) {
                callback(instance);
            }
        });
    }
}
//# sourceMappingURL=instantiation-hook.js.map